import React from 'react';
import "../../css/Words.css";
import Spinner from "../common/Spinner";
import { Card } from "react-bootstrap";

var randomWords = require('random-words');
var Owlbot = require('owlbot-js');
var client = Owlbot('36d0b408534400bdd98694e2fdf30a965387225d');


interface IWordsProps {
}

interface Definition {
  type:string;
  definition: string;
  example: string;
  image_url?: string;
  emoji?: string;
}

interface Response {
  definitions: Definition[],
  word: string;
  pronunciation: string;
}

interface IWordsState {
  response: Response,
}


export default class Words extends React.Component<IWordsProps, IWordsState> {
  componentDidMount() {
    this.fetchWord(randomWords())
  }

  playAudio = (word: string) => {
    var audio_url='https://ssl.gstatic.com/dictionary/static/sounds/20160317/'+word.toLowerCase()+'--_gb_1.mp3'
    var playSound = new Audio(audio_url);
    playSound.play();
  }

  fetchWord = (word:string = "Indelible") => {
    client.define(word).then((result: Response) => {
      const definitions: Response = result;
      this.setState({response: definitions})
    }).catch(err => {
        console.log('error not found', err);
    });
  }

  searchWord = (event) => {
    if (event.key === "Enter" && event.target.value) {
      this.fetchWord(event.currentTarget.value);
    }
  };

  render() {
    if (this.state && this.state.response && this.state.response.definitions.length === 0) {
      return <Spinner />;
    } 
    else {
        return(
          <div className="words">
            <h4>Word of the Day</h4>
              <div className="search-container">
                <input
                  type="text"
                  id="search-bar"
                  placeholder="search word"
                  onKeyPress={this.searchWord}
                />
                <i className="fas fa-search search-icon" />
              </div>
              <hr/>
              { this.state && this.state.response && this.state.response.word && this.state.response.definitions.map((word, index) => {
                return (
                  <Card key={index}>
                     <img src={word.image_url} alt=""/>
                    <Card.Body> 
                      <Card.Title>
                        <p className="word">{this.state.response.word} </p>&nbsp;
                      <img 
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAQAAAC1QeVaAAAAi0lEQVQokWNgQAYyQFzGsIJBnwED8DNcBpK+DM8YfjMUokqxMRxg+A9m8TJsBLLSEFKMDCuBAv/hCncxfGWQhUn2gaVAktkMXkBSHmh0OwNU8D9csoHhO4MikN7BcAGb5H+GYiDdCTQYq2QubkkkY/E6CLtXdiJ7BTMQMnAHXxFm6IICvhwY8AYQLgCw2U9d90B8BAAAAABJRU5ErkJggg==" 
                      alt="audio" onClick={() => this.playAudio(this.state.response.word)}></img>
                      </Card.Title>
                    
                       <p className="defintion">Defintion: <span dangerouslySetInnerHTML={{__html: word.definition}}/></p>
                         <br/>
                       <p className="example">Example: <span  dangerouslySetInnerHTML={{__html: word.example }} /></p> 
                     
                      <p className="type">Type: {word.type}</p>
                      <p className="emoji">Emoji:{word.emoji}</p>
                    </Card.Body>
                </Card>
                );
              })
              }
          </div>
        )
  }
   
}
}
